import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { useNavigate } from '@lib/react-router-dom'

import { Heading6 } from '@ui/Typography'
import { PageSection } from '@ui/components/PageSection'

import { ScrollToIds, useScrollToElementIds } from '@hooks/useScrollToElementIds'

import styles from './MarketDataPage.module.scss'

export const MarketDataHelpPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { scrollIntoView } = useScrollToElementIds()
  scrollIntoView([ScrollToIds.SubscriptionsMarketDataHeader], {
    skipElementsViewportVisibility: true,
  })

  const handleGoBack = () => {
    navigate('/dashboard/subscriptions/market-data')
  }

  return (
    <>
      <PageSection
        title={t('Market Data.title')}
        onGoBack={handleGoBack}
        id={ScrollToIds.SubscriptionsMarketDataHeader}
      />
      <div className={classNames('mt-3', styles.card)}>
        <Heading6 medium>{t('Market Data.Why do I need Market Data')}</Heading6>
        <p className='text mt-4'>
          {t('Market Data.Market Data is what provides you with real-time')}
        </p>
      </div>
    </>
  )
}
